import React from 'react';
import './CheckoutPayment.css';
import { formatAmount, cycleSuffix, productLabel } from '../lib/catalogue';

const CheckoutPayment = ({ product, quantity = 1, customerData, onSubmit, loading }) => {
    const units = Math.max(1, Number(quantity) || 1);
    const unit = product.price_display || '—';
    const subtotal = Number.isFinite(product.price_numeric)
        ? `${formatAmount(product.price_numeric * units, product.currency)} ${cycleSuffix(product)}`.trim()
        : unit;

    return (
        <div className="checkout-step active">
            <div className="step-header">
                <div className="step-number-container">
                    <div className="step-number">3</div>
                </div>
                <h3>Payment</h3>
            </div>
            <div className="step-content">
                <div className="payment-layout">
                    <div className="payment-summary">
                        <h4>Order summary</h4>

                        <div className="summary-row">
                            <span>{productLabel(product)}</span>
                            <span>{unit}</span>
                        </div>
                        {units > 1 && (
                            <div className="summary-row">
                                <span>{product.billingPeriod ? 'Users' : 'Quantity'}</span>
                                <span>× {units}</span>
                            </div>
                        )}
                        <div className="summary-row">
                            <span>Subtotal</span>
                            <span>{subtotal}</span>
                        </div>
                        <div className="summary-row">
                            <span>Tax</span>
                            <span>Calculated at checkout</span>
                        </div>
                        <div className="summary-row total">
                            <span>TOTAL</span>
                            <span>{subtotal}</span>
                        </div>

                        <div className="legal-text">
                            By clicking "Submit order" you are agreeing to Spherene's <a href="https://spherene.io/terms-of-use" target="_blank" rel="noopener noreferrer">Online Purchase Terms</a> and <a href="https://spherene.io/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</a> and agree to Spherene's <a href="https://spherene.io/terms-of-use" target="_blank" rel="noopener noreferrer">Auto-Renewal Terms</a> that your subscriptions will auto-renew. You can change your renewal setting at any time in your Spherene account.
                        </div>

                        <button
                            className="submit-order-btn"
                            onClick={onSubmit}
                            disabled={loading}
                        >
                            {loading ? 'Processing...' : 'Submit order >'}
                        </button>

                        <div className="guarantee">
                            <div className="guarantee-icon">🛡️</div>
                            <div className="guarantee-text">
                                <strong>Money-back guarantee</strong>
                                <p>Try your software risk-free. If you are not completely satisfied, we will refund your eligible subscription subject to the <a href="https://spherene.io/refund-policy" target="_blank" rel="noopener noreferrer">Spherene Return Policy</a>.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckoutPayment;
